module.exports = __webpack_public_path__ + "img/zh_CN.2f6d93d.webp";